import { createReducer, on } from '@ngrx/store';
import * as BrokersActions from './brokers.actions';
import { Broker } from '../../shared/services/admin/brokers.service';

export interface BrokersState {
  brokers: Broker[];
  loading: boolean;
  error: any;
  lastLoaded: number | null;
}

export const initialState: BrokersState = {
  brokers: [],
  loading: false,
  error: null,
  lastLoaded: null,
};

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const reducer = createReducer(
  initialState,
  on(BrokersActions.loadBrokers, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(BrokersActions.loadBrokersSuccess, (state, { brokers }) => ({
    ...state,
    brokers,
    loading: false,
    error: null,
    lastLoaded: Date.now(),
  })),
  on(BrokersActions.loadBrokersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(BrokersActions.createBrokerSuccess, (state, { broker }) => ({
    ...state,
    brokers: [...state.brokers, broker],
  })),
  on(BrokersActions.updateBrokerSuccess, (state, { broker }) => ({
    ...state,
    brokers: state.brokers.map((b) => (b.id === broker.id ? broker : b)),
  })),
  on(BrokersActions.deleteBrokerSuccess, (state, { brokerId }) => ({
    ...state,
    brokers: state.brokers.filter((b) => b.id.toString() !== brokerId.toString()),
  })),
  on(BrokersActions.clearBrokers, (state) => ({
    ...state,
    brokers: [],
    lastLoaded: null,
  })),
);
